<template>
  <section v-loading="loading" id="results-file-upload">
    <div class="container-small-table">
      <div class="qc-upload-block">
        <div class="qc-upload-files-inputs">
          <el-form>
            <div class="case-type-input">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text"> Case Type </label>
                      <el-select
                        placeholder="Select Casetype"
                        v-model="selectedCaseType"
                      >
                        <el-option
                          label="PGX Test"
                          value="PGX_TEST"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text"> Title </label>
                      <el-input
                        v-model="title"
                        placeholder="Please Enter Title"
                      ></el-input>
                      <p class="err" v-if="getErrors && getErrors.title">
                        <FormError errorName="title"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-form>
          <div class="pgx-cnv-file-upload">
            <el-row :gutter="20">
              <el-col :span="12">
                <h3 class="upload-file-header">Result File</h3>
                <ResultFileUpload
                  @onUpdatedFile="handleUploadResultFile"
                ></ResultFileUpload>
              </el-col>
              <el-col :span="12">
                <h3 class="upload-file-header">CNV File</h3>
                <ResultFileUpload
                  @onUpdatedFile="handleUploadCNVFile"
                ></ResultFileUpload>
              </el-col>
              <p class="err" v-if="getErrors && getErrors.critical_error">
                <FormError errorName="critical_error"></FormError>
              </p>
              <el-col :span="24">
                <div class="upload-btn-group">
                  <el-button
                    class="result-upload-btn"
                    @click="submitFileUploadDetails"
                    :disabled="disableSubmitButton"
                  >
                    UPLOAD
                    <span class="el-icon-upload2 submit-btn-arrow"></span>
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
const FormError = defineAsyncComponent(() =>
  import("@/components/misc/FormError")
);
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
const ResultFileUpload = defineAsyncComponent(() =>
  import("@/components/fileUpload/ResultFileUpload")
);
export default {
  components: { ResultFileUpload, FormError },
  computed: {
    ...mapGetters("tsiReports", ["getFileUploadStatus"]),
    ...mapGetters("errors", ["getErrors", "getError"]),
    disableSubmitButton() {
      if (
        this.selectedCaseType == "PGX_TEST" &&
        this.selectedFile &&
        this.cnvFile
      )
        return false;

      return true;
    },
  },
  data() {
    return {
      loading: false,
      title: "",
      formData: {},
      selectedCaseType: "PGX_TEST",
      cnvFile: null,
      selectedFile: null,
      files: [],
      data: [],
    };
  },
  mounted() {
    this.$store.commit("errors/clear");
  },
  methods: {
    handleRemove() {
      this.files = [];
    },
    handleUploadResultFile(file) {
      this.selectedFile = file;
    },
    handleUploadCNVFile(file) {
      this.cnvFile = file;
    },
    handleUpload(file) {
      this.files.push(file.raw);
    },
    handleOnUpload(file) {
      this.files.push(file.raw);
    },
    prepareFormData() {
      let files = new FormData();
      files.append("resultFile", this.selectedFile.raw);
      files.append("cnvFile", this.cnvFile.raw);

      let appendedFiles = [];
      appendedFiles.push(files.get("resultFile"));
      appendedFiles.push(files.get("cnvFile"));
      let formData = new FormData();
      for (let i = 0; i < appendedFiles.length; i++) {
        formData.append("files", appendedFiles[i]);
      }
      formData.append("case_type", this.selectedCaseType);
      formData.append("title", this.title);

      return formData;
    },
    async submitFileUploadDetails() {
      try {
        this.loading = true;
        const formData = this.prepareFormData();

        await this.$store.dispatch("tsiReports/uploadSingleFile", formData);

        if (this.getFileUploadStatus) {
          successNotification("Reports Uploaded Successfully");
          this.$router.push({
            name: "TsiReports",
            path: "/pgx-rpeorts",
          });
        } else if (!this.getErrors) {
          errorNotification(this.getError);
        }
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss">
#results-file-upload {
  .qc-upload-block {
    border: 1.2px solid #e7e7f7;
    border-radius: 5px;
    margin: auto;
    width: 80%;

    .qc-upload-files-inputs {
      padding: 1rem 2rem;
      background-color: #ffffff;
      border-radius: 5px;

      .el-input__inner {
        background: #ffffff;
        border: 0.639774px solid rgba(156, 156, 156, 0.5);
        border-radius: 3.83865px;
      }
    }
  }
  .upload-files {
    margin-bottom: 0 !important;
  }
  .pgx-cnv-file-upload {
    .upload-file-header {
      font-size: 16px;
      padding: 7px 0;
      color: #2a2b2c;
    }
    .qc-upload-files {
      .qc-upload-button {
        .el-upload {
          width: 100%;
          .el-upload-dragger {
            height: 100px;
            width: 100%;
            background: #ffffff;
            border: 1px dashed #bababc;
            border-radius: 5px;
          }
        }
        .el-upload-text-align {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
          .el-upload__text-img {
            display: flex;
            align-items: center;
            img {
              width: 40px;
              height: 40px;
              padding: 0 10px;
            }
          }
          .el-upload-text {
            line-height: 14px;
            h3 {
              color: #333333;
              font-size: 18px;
            }
            p {
              color: #828282;
              font-size: 18px;
            }
          }
        }
        .el-upload-notes {
          color: #828282;
          font-size: 14px;
          font-weight: 500;
          padding: 10px 5px;
        }
      }
      .sample-attachment-file-block {
        width: 100%;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        .sample-attachment-file {
          display: flex;
          align-items: center;
          border: 0.5px solid #e0e0e0;
          border-radius: 5px;
          margin: 1rem 0;
          img {
            padding: 0 10px;
          }
        }
      }
    }
    .upload-btn-group {
      text-align: end;
      margin-top: 15px;
      .el-button {
        background: #4bb543;
        border-radius: 3.40909px;
        width: 120px;
        min-height: 30px;
        height: 36px;
        margin-top: 3px;
        border: none;
        color: white;
        &.result-upload-btn {
          background: #4bb543;
        }
        &.is-disabled {
          opacity: 0.5;
        }
      }
    }
  }
  .pgx-cnv-file-selected {
    ul {
      display: flex;
      li {
        width: 50%;
        margin-right: 20px;
      }
    }
  }
}
</style>
